import React from 'react';

import {
    FormulaSchedulingOptions,
    FormulaSchedulingOptionsLabels,
} from 'models/formula.model';

import { SummaryItem } from './SummaryItem';

export const SchedulingSummary = ({
    schedulingType,
}: {
    schedulingType: FormulaSchedulingOptions;
}) => {
    return (
        <SummaryItem
            label="Scheduling"
            value={FormulaSchedulingOptionsLabels[schedulingType]}
        />
    );
};
